import { z } from 'zod';

export const ReactNativeIpcMessage = z.enum([
  'DOWNLOAD_FILE',
  'SAVE_BASE64_DATA_TO_FILE',
  'SET_SENTRY_USER',
  'UNSET_SENTRY_USER',
  'KV_SET',
  'KV_GET',
  'KV_REMOVE',
  'LOGIN_USER',
  'LOGOUT_USER',
  'GET_FCM_TOKEN',
  'CLEAR_FCM_TOKEN',
]);
